import { TextField, InputAdornment, IconButton } from "@mui/material"
import { AddCircle, RemoveCircle } from "@mui/icons-material"


export const NumberInput = ({ value, label, name, setCurElement, setIsEdited, onChangeHandler, param_global, sx, max_value }) => {
    const incrementValue = (param, param_global) => {
        if (setCurElement) {
            setCurElement(e => {
                let v = parseInt(e[param])
                if (param_global) {
                    return ({ ...e, [param]: v + 1, [param_global]: parseInt(e[param_global]) + 1 })
                } else {
                    return ({ ...e, [param]: v + 1 })
                }
            })
            try {
                setIsEdited(true)
            } catch (err) { }

        } else {
            const v = value+1
            if (max_value && value>=max_value){
                v = max_value
            }
            onChangeHandler({ value: v, name: name })
        }

    }
    const decrementValue = (p, param_global) => {
        if (setCurElement) {
            setCurElement(e => {
                let v = parseInt(e[p])
                if (param_global) {
                    return ({ ...e, [p]: v - 1, [param_global]: parseInt(e[param_global]) - 1 })
                } else {
                    return ({ ...e, [p]: v - 1 })
                }
            })
        } else {
            onChangeHandler({ value: value - 1, name: name })
        }
        try {
            setIsEdited(true)

        } catch (err) { }

    }


    return (

        <TextField
            sx={sx}
            margin="dense"
            id={name}
            label={label}
            name={name}
            variant="standard"
            type="number"
            value={value}
            onChange={(ev) => onChangeHandler(ev.target, param_global)}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton disabled={max_value && parseInt(value) >= max_value} edge="end" color="primary" onClick={() => incrementValue(name, param_global)}>
                            <AddCircle />
                        </IconButton>
                    </InputAdornment>
                ),
                startAdornment: (
                    <InputAdornment position="start">
                        <IconButton disabled={parseInt(value) < 2} edge="start" color="primary" onClick={() => decrementValue(name, param_global)}>
                            <RemoveCircle />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    )
}